/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getUpdateHash} from '../api'

 export const useQueryGetUpdateHash = createReactQueryHook('getUpdateHash', getUpdateHash)
